import { queryKeys } from '@/hooks/query-keys'

/**
 * Query key for Files / Notes list-column counts. It sits under
 * `documents.counts()` so the documents realtime feed refreshes it with the
 * other file counts. Trailing parts are optional, so a caller can refresh
 * one record, a whole module or every record at once.
 */
export function recordAttachmentCountsKey(
  moduleType?: string,
  recordId?: string,
  organizationId?: string,
) {
  const defined: string[] = []
  for (const part of [moduleType, recordId, organizationId]) {
    if (part === undefined) break
    defined.push(part)
  }
  return [...queryKeys.documents.counts(), 'records', ...defined] as const
}

type CountsChangedListener = (moduleType?: string, recordId?: string) => void

// Set by the counts hook with its query client, so API modules can signal a
// change without importing the app's query client.
let countsChangedListener: CountsChangedListener | null = null

export function setRecordAttachmentCountsListener(
  listener: CountsChangedListener,
) {
  countsChangedListener = listener
}

/** Refresh counts after files or notes change (every record when unscoped).
 * Only mounted count cells refetch; nothing happens before any has mounted. */
export function invalidateRecordAttachmentCounts(
  moduleType?: string,
  recordId?: string,
) {
  countsChangedListener?.(moduleType?.toUpperCase(), recordId)
}
